import ReactSelect, { formatDotLabel, formatDotStyles } from '../ReactSelect';
import React from 'react';
import colors from '../../theme/colors';

export type AssemblyResult = 'PASS' | 'FAIL' | 'FAILPASS';

const resultOptions = [
  {
    label: 'Pass',
    value: 'PASS',
    color: colors.statusSuccess,
  },
  {
    label: 'Fail',
    value: 'FAIL',
    color: colors.statusError,
  },
  {
    label: 'Fail/Pass',
    value: 'FAILPASS',
    color: colors.failPass,
  },
] as const;

export const AssemblyResultPicker = ({
  value,
  onChange,
}: {
  value?: AssemblyResult[];
  onChange: (value?: AssemblyResult[]) => void;
}) => {
  return (
    <ReactSelect
      placeholder="last result"
      isMulti
      isClearable={false}
      value={resultOptions.filter((option) => value?.includes(option.value))}
      styles={{
        menu: (base) => ({
          ...base,
          minWidth: '120px',
        }),
        multiValue: formatDotStyles,
      }}
      formatOptionLabel={formatDotLabel}
      onChange={(values) => {
        if (Array.isArray(values)) {
          onChange(
            values.length > 0 ? values.map((value1) => value1.value) : undefined
          );
        } else {
          onChange(undefined);
        }
      }}
      options={resultOptions}
    />
  );
};
